<template>
    <div>
        <Header></Header>
        <div class="main-table">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">就医记录</el-breadcrumb-item>
                <el-breadcrumb-item>药品医嘱</el-breadcrumb-item>
            </el-breadcrumb>
            <el-table
                    :data="list"
                    stripe
                    size="medium"
                    style="width:100%;margin-top:20px;">
                <el-table-column prop="ksrq" label="开始日期" width="100"></el-table-column>
                <el-table-column prop="tzrq" label="结束日期" width="100"></el-table-column>
                <el-table-column prop="xh" label="序号" width="50"></el-table-column>
                <el-table-column prop="zh" label="组号" width="50"></el-table-column>
                <el-table-column prop="ypmc" label="药品名称" ></el-table-column>
                <el-table-column prop="ypgg" label="药品规格" ></el-table-column>
                <el-table-column prop="fyjl" label="服用剂量" ></el-table-column>
                <el-table-column prop="jldw" label="剂量单位" ></el-table-column>
                <el-table-column prop="pc" label="频次" ></el-table-column>
                <el-table-column prop="yyff" label="用药方法" ></el-table-column>
                <el-table-column prop="bz" label="备注" ></el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next ,total"
                    :page-size="pageSize"
                    :total="totalSize"
                    :current-page.sync="currentPage"
                    @current-change="changePage">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import Header from './components/Header.vue'
    import {findYpyz} from '@/api/biApi.js'
    export default{
        data(){
            return {
                list:[],
                id:'',
                currentPage:1,
                pageSize:15,
                totalSize:0,
            }
        },
        components: {
            Header
        },
        mounted(){
            this.id = this.$route.params.id
            if(!this.id){
                this.$router.push({ name: '/'})
            }
            this.getList(1,this.pageSize)
        },
        methods:{
            getList(page,size){
                this.currentPage = page
                this.list = [];
                findYpyz({
                    "jzlsh":this.id,
                    "size":size,
                    "page":page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        this.list = res.list
                    }
                    this.totalSize = res && res.total ? res.total : 0;
                }).catch(err=>{
                    this.$message.error('获取药品医嘱记录失败');
                })
            },
            changePage(page){
                this.getList(page,this.pageSize)
            },
        }
    }
</script>
<style lang="scss">
    .main-table{
        max-width: 1280px;
        margin:0 auto;
        padding-left:10px;
        padding-right:10px;

        .el-pagination{
            float: right;
            margin: 10px 0px 10px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc/jyjl-ypyz.vue